module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: {
      "modal-lg": !_vm.selected_contact, "auto-width": _vm.show_calendar
    }
  }, [_c('div', {
    class: {
      "container": _vm.show_calendar
    }
  }, [_c('div', {
    class: {
      'row': _vm.show_calendar
    }
  }, [_c('div', {
    class: {
      'col-md-8 col-sm-8': _vm.show_calendar
    }
  }, [_c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "modal_form_dialog"
    }
  }, [(!_vm.selected_contact) ? _c('contact-picker', {
    on: {
      "contact-selected": _vm.setSelectedContact
    }
  }) : [_c('task-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.removing),
      expression: "!removing"
    }],
    attrs: {
      "task": _vm.task,
      "contact": _vm.selected_contact,
      "can_change_contact": !_vm.contact,
      "show_stage_selection": _vm.show_stage_selection,
      "origem": "Tarefas"
    },
    on: {
      "removing": function($event) {
        _vm.removing = true
      },
      "change-contact": _vm.setSelectedContact,
      "open-template-modal": _vm.bubbleUp
    }
  }), _c('confirm-destroy', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removing),
      expression: "removing"
    }],
    attrs: {
      "task": _vm.task
    },
    on: {
      "destroyed": _vm.taskDestroyed,
      "cancel-removing": function($event) {
        _vm.removing = false
      }
    }
  })]], 2)]), (_vm.show_calendar) ? _c('div', {
    staticClass: "padding_left_zero col-md-4 col-sm-4"
  }, [_c('daily-events')], 1) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c726298!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/modal_form.vue
// module id = 1055
// module chunks = 1